module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('app-raster-legend', {
    ref: "legend",
    staticClass: "app-raster-legend",
    staticStyle: {
      "position": "absolute",
      "bottom": "50px",
      "margin-left": "15px",
      "z-index": "1"
    },
    attrs: {
      "value": _vm.isActive && !_vm.isDynamicStyle,
      "layout": "vertical"
    }
  }), _vm._v(" "), _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "disable-resize-watcher": "",
      "hide-overlay": "",
      "mobile-break-point": "0",
      "value": _vm.isActive,
      "width": "500"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "extension-height": "80"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('historico')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('disableControl')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticStyle: {
      "margin": "0px auto",
      "width": "100%"
    },
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('app-select-indicador', {
    attrs: {
      "disabled": _vm.isPlaying
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('app-select-period', {
    attrs: {
      "disabled": _vm.isPlaying
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "mx-3",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container-buttons"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin": "0px auto"
    },
    attrs: {
      "slot": "activator",
      "fab": "",
      "small": "",
      "color": _vm.isDynamicStyle ? 'red darken-2' : 'blue darken-1',
      "disabled": _vm.isPlaying
    },
    on: {
      "click": function($event) {
        _vm.isDynamicStyle = !_vm.isDynamicStyle
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("palette")])], 1), _vm._v(" "), _c('span', [_vm._v("Cambiar estilo")])], 1)], 1)])], 1), _vm._v(" "), _c('app-raster-filter', {
    ref: "rasterFilter",
    attrs: {
      "rasterLayer": _vm.LayerRaster,
      "value": _vm.isDynamicStyle && _vm.isActive
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-card', {
    staticClass: "my-3",
    attrs: {
      "dark": !_vm.$store.getters.isDarkTheme,
      "light": _vm.$store.getters.isDarkTheme
    }
  }, [_c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "height": "5",
      "value": (_vm.loaded == 0 ? 0 : (100 * _vm.loading / _vm.loaded) | 0)
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-select', {
    attrs: {
      "items": _vm.velocitiesKeys,
      "solo": "",
      "background-color": ("green " + (_vm.$store.getters.isDarkTheme ? 'lighten-2' : 'darken-2')),
      "item-text": "displayName",
      "prepend-inner-icon": "slow_motion_video",
      "append-icon": "keyboard_arrow_down",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.velocity),
      callback: function($$v) {
        _vm.velocity = $$v
      },
      expression: "velocity"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-subheader', {
    attrs: {
      "light": _vm.$store.getters.isDarkTheme
    }
  }, [_vm._v(_vm._s(_vm.$t('año')))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-slider', {
    staticClass: "my-0",
    attrs: {
      "min": _vm.minYear,
      "max": _vm.maxYear,
      "disabled": _vm.isPlaying,
      "dark": !_vm.$store.getters.isDarkTheme,
      "light": _vm.$store.getters.isDarkTheme,
      "color": "primary",
      "hide-details": "",
      "thumb-label": true
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.period == _vm.periodModes.MENSUAL),
      expression: "period == periodModes.MENSUAL"
    }],
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-subheader', {
    attrs: {
      "light": _vm.$store.getters.isDarkTheme
    }
  }, [_vm._v(_vm._s(_vm.$t('mes')))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-slider', {
    staticClass: "my-0",
    attrs: {
      "min": 0,
      "max": 11,
      "disabled": _vm.isPlaying,
      "dark": !_vm.$store.getters.isDarkTheme,
      "light": _vm.$store.getters.isDarkTheme,
      "color": "primary",
      "hide-details": "",
      "thumb-label": true
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.period == _vm.periodModes.TRIMESTRAL),
      expression: "period == periodModes.TRIMESTRAL"
    }],
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-subheader', {
    attrs: {
      "light": _vm.$store.getters.isDarkTheme
    }
  }, [_vm._v(_vm._s(_vm.$t('trimestre')))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-slider', {
    staticClass: "my-0",
    attrs: {
      "min": 0,
      "max": 3,
      "disabled": _vm.isPlaying,
      "dark": !_vm.$store.getters.isDarkTheme,
      "light": _vm.$store.getters.isDarkTheme,
      "color": "primary",
      "hide-details": "",
      "thumb-label": true
    },
    model: {
      value: (_vm.trim),
      callback: function($$v) {
        _vm.trim = $$v
      },
      expression: "trim"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "light": _vm.$store.getters.isDarkTheme
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Histórico de " + _vm._s(_vm.indicador))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.raster ? _vm.raster.displayName : 'Sin datos'))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "disabled": !_vm.canGoBack || _vm.isPlaying,
      "icon": "",
      "light": _vm.$store.getters.isDarkTheme
    },
    on: {
      "click": function($event) {
        _vm.handleDirection(_vm.directionModes.PREV)
      }
    }
  }, [_c('v-icon', [_vm._v("fast_rewind")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', {
    class: {
      'mx-3': _vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.period == _vm.periodModes.ANUAL && _vm.yearsList.length <= 1,
      "icon": "",
      "light": _vm.$store.getters.isDarkTheme
    },
    on: {
      "click": _vm.handlePlayerButton
    }
  }, [(_vm.isPlaying) ? _c('v-icon', [_vm._v("pause")]) : (!_vm.isPlaying && _vm.canGoNext) ? _c('v-icon', [_vm._v("play_arrow")]) : _c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', {
    class: {
      'mr-3': _vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.canGoNext || _vm.isPlaying,
      "icon": "",
      "light": _vm.$store.getters.isDarkTheme
    },
    on: {
      "click": function($event) {
        _vm.handleDirection(_vm.directionModes.NEXT)
      }
    }
  }, [_c('v-icon', [_vm._v("fast_forward")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d27b514","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/player/Player.vue
// module id = 1049
// module chunks = 1